import script from "./Task.vue?vue&type=script&setup=true&lang=js"
export * from "./Task.vue?vue&type=script&setup=true&lang=js"

import "./Task.vue?vue&type=style&index=0&id=51d20c70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d20c70"]])

export default __exports__